import { Language } from '@coolblue-development/constants';
export const STUDENT_DISCOUNT_PATHS = [
    '/studentenkorting/verificatie',
    '/student-discount/verification',
    '/reduction-etudiant/verification',
    '/studentenrabatt/verifizierung',
];
export const STOREFRONTS_PATHS_FOR_STUDENT_DISCOUNT = {
    [Language.DUTCH]: [
        '/laptops',
        '/laptops/studentenkorting',
        '/laptops/back-to-school',
        '/back-to-school',
        '/laptops/apple-macbook',
        '/laptops/windows',
        '/laptops/hp',
        '/laptops/lenovo',
        '/laptops/asus',
        '/laptops/samsung',
        '/apple',
        '/laptops/apple-macbook/apple-macbook-air',
        '/laptops/lenovo/lenovo-yoga',
    ],
    [Language.ENGLISH]: [
        '/laptops',
        '/laptops/student-discount',
        '/laptops/back-to-school',
        '/back-to-school',
        '/laptops/apple-macbook',
        '/laptops/windows',
        '/laptops/hp',
        '/laptops/lenovo',
        '/laptops/asus',
        '/laptops/samsung',
        '/apple',
        '/laptops/apple-macbook/apple-macbook-air',
        '/laptops/lenovo/lenovo-yoga',
    ],
    [Language.FRENCH]: [
        '/ordinateurs-portables',
        '/ordinateurs-portables/reduction-etudiant',
        '/ordinateurs-portables/back-to-school',
        '/back-to-school',
        '/ordinateurs-portables/apple-macbook',
        '/ordinateurs-portables/windows',
        '/ordinateurs-portables/hp',
        '/ordinateurs-portables/lenovo',
        '/ordinateurs-portables/asus',
        '/ordinateurs-portables/samsung',
        '/apple',
        '/laptops/apple-macbook/apple-macbook-air',
        '/laptops/lenovo/lenovo-yoga',
    ],
    [Language.GERMAN]: [
        '/laptops',
        '/laptops/studentenrabatt',
        '/laptops/back-to-school',
        '/back-to-school',
        '/laptops/apple-macbook',
        '/laptops/windows',
        '/laptops/hp',
        '/laptops/lenovo',
        '/laptops/asus',
        '/laptops/samsung',
        '/apple',
        '/laptops/apple-macbook/apple-macbook-air',
        '/laptops/lenovo/lenovo-yoga',
    ],
};
//# sourceMappingURL=urls.js.map